import aceRequest from '../ace-request';

(() => {
  window.atex = window.atex || {};
  window.atex.aceui = window.atex.aceui || {};
  window.atex.aceui.service = window.atex.aceui.service || {};

  window.atex.aceui.service.WorkflowService = (workflowServiceUrl) => {
    return {
      initialize: ({ token, target, workflowId, alias, comment, revision }) => {
        return aceRequest ({
          token,
          method: 'PUT',
          url: `${workflowServiceUrl}/init`,
          matcher: revision,
          body: {
            workflowId,
            targetState: target,
            alias,
            comment
          }
        })
          .then ((response) => {
            return response.body;
          })
          .catch ((error) => {
            let e = atex.aceui.HTTPUtils.createError(error, 'atex.aceui.service.WorkflowService', {
              400: 'Bad request when initializing workflow',
              401: 'Could not authenticate user while initializing workflow "' + workflowId + '" for "' + alias + '"',
              403: 'Permission denied initializing workflow for "' + alias + '" from the server',
              409: 'Content has been modified, cannot initialize workflow',
              404: 'No workflow for id "' + workflowId + '" was not found on the server (404)',
              'default': 'There was an error while initializing workflow "' + workflowId + '"'
            });

            e.rootCause = error.rootCause;

            throw e;
          });

      },
      transition: ({ token, target, workflowId, alias, comment, revision }) => {
        return aceRequest ({
          token,
          method: 'PUT',
          url: `${workflowServiceUrl}/transition`,
          matcher: revision,
          body: {
            workflowId,
            targetState: target,
            alias,
            comment
          }
        })
          .then ((response) => {
            return response.body;
          })
          .catch ((error) => {
            throw atex.aceui.HTTPUtils.createError(error, 'atex.aceui.service.WorkflowService', {
              401: 'Could not authenticate user while performing workflow transition in "' + workflowId + '" for "' + alias + '"',
              403: 'Permission denied performing workflow transition for "' + alias + '" from the server',
              409: 'Content has been modified, cannot perform workflow transition.',
              'default': 'Could not perform workflow transition into "' + target + '" for workflow "' + workflowId + '"'
            });
          });
      },
      abort: ({ token, workflowId, alias, comment, revision }) => {
        return aceRequest ({
          token,
          method: 'PUT',
          url: `${workflowServiceUrl}/abort`,
          matcher: revision,
          body: {
            workflowId,
            alias,
            comment
          }
        })
          .then ((response) => {
            return response.body;
          })
          .catch ((error) => {
            let e = atex.aceui.HTTPUtils.createError(error.rootCause.request, 'atex.aceui.service.WorkflowService', {
              400: 'Bad request when aborting workflow',
              401: 'Could not authenticate user while aborting workflow "' + workflowId + '" for "' + alias + '"',
              403: 'Permission denied aborting workflow for "' + alias + '" from the server',
              409: 'Content has been modified, cannot perform workflow transition.',
              'default': 'There was an error while aborting workflow "' + workflowId + '"'
            });

            if (typeof e.rootCause !== 'undefined') {
              e.rootCause.textStatus = error.statusText;
              e.rootCause.errorThrown = error;
              e.rootCause.requestArgs = { token, workflowId, alias, comment };
            }

            e.severity = atex.aceui.error.severities.MAJOR;

            throw e;
          });
      },
      getWorkflow: async ({ token, workflowId }) => {
        try {
          let response = await aceRequest ({ url: `${workflowServiceUrl}/${workflowId}`, token, workflowId });
          return response.body;
        } catch (error) {
          let e = atex.aceui.HTTPUtils.createError(error.rootCause.request, 'atex.aceui.service.WorkflowService', {
            404: '(404) No workflow for ' + workflowId,
            default: 'Error when getting workflow for ' + workflowId
          });

          if (typeof e.rootCause !== 'undefined') {
            e.rootCause.textStatus = error.statusText;
            e.rootCause.errorThrown = error;
            e.rootCause.requestArgs = { token, workflowId };
          }

          throw e;          
        }
      },
      getWorkflowFor: ({ token, contentType }) => {
        return aceRequest ({ url: `${workflowServiceUrl}/for/${contentType}`, token, contentType })
          .then ((response) => {
            return response.body;
          })
          .catch ((error) => {
            let e = atex.aceui.HTTPUtils.createError(error.rootCause.request, 'atex.aceui.service.WorkflowService', {
              404: '(404) No workflow for ' + contentType,
              default: 'Error when getting workflow for ' + contentType
            });

            if (typeof e.rootCause !== 'undefined') {
              e.rootCause.textStatus = error.statusText;
              e.rootCause.errorThrown = error;
              e.rootCause.requestArgs = { token, contentType };
            }

            throw e;
          });
      }
    };
  };
})();
